import { MoveMapPointDto } from '@routellers/types/dist/city-ready-route/move-map-point.dto';
import { CityReadyRouteRO } from '@routellers/types/dist/city-ready-route/city-ready-route.ro';
import { CreateCityReadyRouteDto } from '@routellers/types/dist/city-ready-route/create-city-ready-route.dto';
import {
    EstimateReadyRoutePathDto,
    EstimateReadyRoutePathRO,
} from '@routellers/types/dist/city-ready-route/estimate-ready-route-path.dto';
import { ReadyRouteMapPoolRO } from '@routellers/types/dist/city-ready-route/ready-route-map-pool.ro';
import { UpdateCityReadyRouteDto } from '@routellers/types/dist/city-ready-route/update-city-ready-route.dto';
import { QueryDto } from '@routellers/types/dist/shared/query.dto';
import { QueryRO } from '@routellers/types/dist/shared/query.ro';

import { ApiMethodDeclaration } from '..';

const query: ApiMethodDeclaration<QueryDto, QueryRO<CityReadyRouteRO>> = (params) => ({
    url: '/admin/city-ready-routes',
    method: 'GET',
    params,
});

const getOne: ApiMethodDeclaration<number, CityReadyRouteRO> = (id) => ({
    url: `/admin/city-ready-routes/${id}`,
    method: 'GET',
});

const create: ApiMethodDeclaration<{ data: CreateCityReadyRouteDto }, CityReadyRouteRO> = ({
    data,
}) => ({
    url: '/admin/city-ready-routes',
    method: 'POST',
    data,
});

const update: ApiMethodDeclaration<
    { id: number; data: UpdateCityReadyRouteDto },
    CityReadyRouteRO
> = ({ id, data }) => ({
    url: `/admin/city-ready-routes/${id}`,
    method: 'PATCH',
    data,
});

const remove: ApiMethodDeclaration<number, { success: boolean }> = (id) => ({
    url: `/admin/city-ready-routes/${id}`,
    method: 'DELETE',
});

const mapPool: ApiMethodDeclaration<{ cityId: number }, ReadyRouteMapPoolRO> = ({ cityId }) => ({
    url: '/admin/city-ready-routes/map-pool',
    method: 'GET',
    params: { cityId },
});

const estimatePath: ApiMethodDeclaration<
    { data: EstimateReadyRoutePathDto },
    EstimateReadyRoutePathRO
> = ({ data }) => ({
    url: '/admin/city-ready-routes/estimate-path',
    method: 'POST',
    data,
});

const moveMapPoint: ApiMethodDeclaration<
    { routeId: number; data: MoveMapPointDto },
    { lat: number; lng: number }
> = ({ routeId, data }) => ({
    url: `/admin/city-ready-routes/${routeId}/map-point`,
    method: 'PATCH',
    data,
});

export const cityReadyRoutesApiDeclaration = {
    moveMapPoint,
    query,
    getOne,
    create,
    update,
    remove,
    mapPool,
    estimatePath,
};
